var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import DeleteIcon from "@mui/icons-material/Delete";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import MergeTypeIcon from "@mui/icons-material/MergeType";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { Alert, Box, Button, Card, CardContent, Chip, Divider, Grid, Typography, } from "@mui/material";
import { formatDistanceToNow } from "date-fns";
import React from "react";
import { Link } from "react-router-dom";
import { useCancelLeagueTeamInvitation, useListLeagueInvitations, } from "../api/InvitationApiProvider";
import { useRetrieveLeague } from "../api/LeagueApiProvider";
import { useRetrieveUserLeaguePermissions } from "../api/PermissionApiProvider";
import { ROUTES } from "../breadcrumbs/routeConfig";
import { EmptyState } from "../common/EmptyState";
import { ErrorView } from "../nav/Error";
import { Forbidden } from "../nav/Forbidden";
import { Loading } from "../nav/Loading";
import { DeleteDialog } from "../utils/DeleteDialog";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import SuccessSnackbar from "../utils/SuccessSnackbar";
import { useNumericParams } from "../utils/useNumericParams";
export var LeagueInvitations = function () {
    var leagueId = useNumericParams().id;
    var _a = useRetrieveUserLeaguePermissions({ leagueId: leagueId }), permissions = _a.data, isPermLoading = _a.isLoading;
    var canModify = (permissions === null || permissions === void 0 ? void 0 : permissions.canModify) === true;
    var _b = useRetrieveLeague({ id: leagueId, enabled: canModify }), league = _b.data, isLeagueLoading = _b.isLoading, leagueError = _b.error;
    var _c = useListLeagueInvitations({ leagueId: leagueId, enabled: canModify }), invitations = _c.data, isInvLoading = _c.isLoading, invError = _c.error;
    var _d = __read(React.useState(""), 2), successMessage = _d[0], setSuccessMessage = _d[1];
    var _e = __read(React.useState(""), 2), errorMessage = _e[0], setErrorMessage = _e[1];
    if (isPermLoading || (canModify && (isLeagueLoading || isInvLoading))) {
        return _jsx(Loading, {});
    }
    if (!canModify) {
        return _jsx(Forbidden, {});
    }
    if (leagueError || invError || !league) {
        return _jsx(ErrorView, { error: leagueError || invError });
    }
    return (_jsxs(React.Fragment, { children: [_jsxs(Grid, { container: true, spacing: 2, alignItems: "center", children: [_jsx(Grid, { item: true, xs: true, children: _jsxs(Typography, { variant: "h4", gutterBottom: true, children: ["Team Invitations \u2014 ", league.name] }) }), _jsx(Grid, { item: true, children: _jsx(Link, { to: ROUTES.LEAGUE_INVITATIONS_SEND.replace(":id", String(leagueId)), style: { textDecoration: "none" }, children: _jsx(Button, { variant: "contained", color: "primary", startIcon: _jsx(PersonAddIcon, {}), children: "Invite Team" }) }) })] }), _jsx(Divider, { sx: { my: 2 } }), invitations && invitations.length > 0 ? (_jsx(Grid, { container: true, spacing: 2, children: invitations.map(function (inv) { return (_jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, children: _jsx(PendingInvitationCard, { invitation: inv, leagueId: leagueId, onSuccess: setSuccessMessage, onError: setErrorMessage }) }, inv.id)); }) })) : (_jsx(EmptyState, { icon: _jsx(MailOutlineIcon, {}), heading: "No pending invitations", description: "Invite a team to join this league." })), _jsx(SuccessSnackbar, { open: !!successMessage, onClose: function () { return setSuccessMessage(""); }, message: successMessage }), _jsx(ErrorSnackbar, { open: !!errorMessage, onClose: function () { return setErrorMessage(""); }, message: errorMessage })] }));
};
var PendingInvitationCard = function (_a) {
    var invitation = _a.invitation, leagueId = _a.leagueId, onSuccess = _a.onSuccess, onError = _a.onError;
    var _b = __read(React.useState(false), 2), showCancel = _b[0], setShowCancel = _b[1];
    var cancelMutation = useCancelLeagueTeamInvitation({
        onMutate: function () { },
        onSuccess: function () {
            setShowCancel(false);
            onSuccess("Invitation cancelled.");
        },
        onError: function () {
            setShowCancel(false);
            onError("Failed to cancel invitation.");
        },
    });
    return (_jsxs(_Fragment, { children: [_jsx(DeleteDialog, { open: showCancel, title: "Cancel this invitation?", onCancel: function () { return setShowCancel(false); }, onConfirm: function () {
                    return cancelMutation.mutate({
                        invitationId: invitation.id,
                        leagueId: leagueId,
                    });
                } }), _jsx(Card, { variant: "outlined", children: _jsxs(CardContent, { children: [_jsx(Typography, { variant: "h6", noWrap: true, children: invitation.teamName }), _jsxs(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 1 }, children: ["Invited by ", invitation.inviterFirstName, " ", invitation.inviterLastName] }), invitation.mergeTeamName && (_jsx(Alert, { severity: "warning", icon: _jsx(MergeTypeIcon, {}), sx: { mb: 1, py: 0.5 }, children: _jsxs(Typography, { variant: "body2", children: [_jsx("strong", { children: "Merge:" }), " ", _jsx(Link, { to: ROUTES.TEAM_DETAIL.replace(":id", String(invitation.mergeTeam)), children: invitation.mergeTeamName }), " ", "\u2192 ", invitation.teamName] }) })), invitation.message && (_jsxs(Typography, { variant: "body2", sx: { mb: 1, fontStyle: "italic" }, children: ["\u201C", invitation.message, "\u201D"] })), _jsxs(Box, { sx: {
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mt: 1,
                            }, children: [_jsx(Chip, { label: formatDistanceToNow(new Date(invitation.createdAt), {
                                        addSuffix: true,
                                    }), size: "small", variant: "outlined" }), _jsx(Button, { size: "small", color: "error", startIcon: _jsx(DeleteIcon, {}), onClick: function () { return setShowCancel(true); }, children: "Cancel" })] })] }) })] }));
};
